import { recordEventCustomOnly } from 'utilities/uTagging';

const PAGE_NAME = '/onboarding/success/accountActivation';

const buildTagging = () => {
    const doTagContinueButtonClick = () => {
        recordEventCustomOnly({
            action: 'click',
            format: 'button',
            component: 'form',
            element: 'understood',
            categoriaEvento: PAGE_NAME,
            accionEvento: 'clickButton',
            etiquetaEvento: 'understoodButton',
        });
    };

    return { doTagContinueButtonClick };
};

export default buildTagging;
